export default "/images/vendor/flag-icons/flags/1x1/cy.svg?3975224c1deed52e5e3272233922b5e5";